import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { REVIEW_CONSTANTS } from '../../../constants';
import Rating from '../../../../products/components/rating/Rating';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import styles from './Review.module.sass';

const DESKTOP_WIDTH_BREAKPOINT = 600;

function displayReadMore(content) {
  if (!content) {
    return content;
  }
  return content.length > REVIEW_CONSTANTS.TEXT_LENGTH_LIMIT;
}

function getShortText(content) {
  if (content && content.length > REVIEW_CONSTANTS.TEXT_LENGTH_LIMIT) {
    return content.slice(0, REVIEW_CONSTANTS.TEXT_LENGTH_LIMIT).concat('...');
  }
  return content;
}
class Review extends Component {
  constructor(props) {
    super(props);

    this.state = {
      readMore: false,
      replyReadMore: false,
    };
  }

  componentDidMount() {
    window.lazyLoad.update();
  }

  toggleReadMore = () => {
    this.setState((prevState) => ({
      readMore: !prevState.readMore,
    }));
  };

  toggleReplyReadMore = () => {
    this.setState((prevState) => ({
      replyReadMore: !prevState.replyReadMore,
    }));
  };

  openImageModal = (imageUrl) => {
    const { openImageModal } = this.props;

    openImageModal(imageUrl);
  };

  render() {
    const {
      review: {
        content, rating,
        reply: { created_at: replyCreatedAt, content: replyContent },
        created_at: createdAt, user_name: userName,
        images,
      }, isCampaign, customColor = 'black',
    } = this.props;
    const { readMore, replyReadMore } = this.state;
    const displayedText = readMore ? content : getShortText(content);
    const needDisplayReadMore = displayReadMore(content);
    const displayedReplyText = replyReadMore ? replyContent : getShortText(replyContent);
    const needDisplayReplyReadMore = displayReadMore(replyContent);
    return (
      <div className={styles.review}>
        { !isCampaign && (
          <MediaQuery query={`(min-width: ${DESKTOP_WIDTH_BREAKPOINT}px)`}>
            <Rating rating={Number(rating)} className={styles['review-stars-rating-desktop']} color={customColor} />
          </MediaQuery>
        )}
        <div className={styles['review-info']}>
          <div className={styles['reviewer-name-and-rating']}>
            <span style={isCampaign ? { color: customColor } : null} className={styles.name}>
              {userName}
            </span>
            { !isCampaign && (
              <MediaQuery query={`(max-width: ${DESKTOP_WIDTH_BREAKPOINT - 1}px)`}>
                <Rating rating={Number(rating)} className={styles['review-stars-rating']} color={customColor} />
              </MediaQuery>
            )}
          </div>
          <span className={styles.date}>{ createdAt }</span>
        </div>
        <div className={styles['review-text']}>
          { displayedText }
          { needDisplayReadMore && (
            <ClickableDiv className={styles['read-more']} onClick={this.toggleReadMore}>
                {readMore ? 'Hide' : 'Read more'}
            </ClickableDiv>
          )}
        </div>
        { images.length > 0 && (
          <div className={styles.images}>
            { images.map((image) => (
              <ClickableDiv
                className={styles.image}
                key={image.id}
                onClick={() => this.openImageModal(image.source.url)}
              >
                <img data-src={image.source.thumb.url} alt="review" className="lazyload" />
              </ClickableDiv>
            ))}
          </div>
        )}
        { displayedReplyText && (
          <div className={styles.reply}>
            <div className={styles['review-info']}>
              <div className={styles['reviewer-name-and-rating']}>
                <span className={styles.name}>VOLITION CUSTOMER CARE</span>
              </div>
              <span className={styles.date}>{ replyCreatedAt }</span>
            </div>
            <div className={styles['review-text']}>
              { displayedReplyText }
              { needDisplayReplyReadMore && (
              <ClickableDiv className={styles['read-more']} onClick={this.toggleReplyReadMore}>
                {replyReadMore ? 'Hide' : 'Read more'}
              </ClickableDiv>
              )}
            </div>
          </div>
        )}
        <div className={styles.schema} itemProp="review" itemType="http://schema.org/Review">
          <div itemProp="author">
            {userName}
          </div>
          <div itemProp="datePublished">
            { createdAt }
          </div>
          <div itemProp="reviewRating" itemType="http://schema.org/Rating">
            {Number(rating)}
          </div>
          <div itemProp="description">
            { content }
          </div>
        </div>
      </div>
    );
  }
}

Review.propTypes = {
  isCampaign: PropTypes.bool,
  customColor: PropTypes.string,
  review: PropTypes.shape({
    id: PropTypes.number,
    content: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    user_name: PropTypes.string,
    rating: PropTypes.number,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        source: PropTypes.shape({
          thumb: PropTypes.shape({
            url: PropTypes.string,
          }),
        }),
      }),
    ),
    reply: PropTypes.shape({
      content: PropTypes.string,
      created_at: PropTypes.string,
    }),
  }).isRequired,
  openImageModal: PropTypes.func.isRequired,
};

export default Review;
